import Navigatie from "../../components/navigaties";
import Footers from "../../components/footers";
import { Helmet } from "react-helmet";
import BreadCrumb from "../../components/breadcrumb";

function P_Student_Inschrijven(props) {
    function renderNav() {
        if (props.location.pathname.includes("student")) {
            return <Navigatie type="studenten" />;
        } else if (props.location.pathname.includes("bedrijf")) {
            return <Navigatie type="bedrijven" />;
        } else {
            return <Navigatie type="home" />;
        }
    }

    function renderBreadCrumb() {
        if (props.location.pathname.includes("student")) {
            return <BreadCrumb prev={[["/student", "Home"]]} now="Wefynd" />;
        } else if (props.location.pathname.includes("bedrijf")) {
            return <BreadCrumb prev={[["/bedrijf", "Home"]]} now="Wefynd" />;
        } else {
            return <BreadCrumb prev={[["/", "Home"]]} now="Wefynd" />;
        }
    }

    return (
        <div className="mr-t-33" style={{ color: "black" }}>
            <Helmet>
                <title>HR - inschrijven</title>
            </Helmet>
            {renderNav()}
            <div className="container w-71.5 xl-w-82.5 m-w-99">
                {renderBreadCrumb()}
                <div className="pd-4 mr-t-8">
                    <h1 className="mr-b-8">Schrijf je in voor het Job & Stage Event 2026!</h1>
                    <p>
                        Inschrijven kan via Currvit op <a href="https://currvit.com/student/join?a=aOBvIho0hYePhXVgs9rMBL6UMjZ2&e=wa796fA6FwuB9rOrUH82" style={{ color: "black", textDecoration: "underline" }}>deze link</a> of deze QR-code:
                    </p>
                    <img src="/images/jse2026/QRcode_JSE2026.jpg" alt="QR code" />
                    <br />
                    <p>
                        Praktische informatie over het Job & Stage Event 2026 kan je <a href="https://recruitment.hermesgent.be/student/job-en-stage-event" style={{ color: "black" }}>hier</a> vinden.
                    </p>
                </div>
            </div>
            <Footers type="main" />
        </div>
    );
}

export default P_Student_Inschrijven;
